export default "__VITE_ASSET__CrtKIf6X__"